var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 10V5C3.5 2.23858 5.73858 0 8.5 0C11.2614 0 13.5 2.23858 13.5 5V7H11.5V5C11.5 3.34315 10.1569 2 8.5 2C6.84315 2 5.5 3.34315 5.5 5V10H14.5C15.6046 10 16.5 10.8954 16.5 12V20C16.5 21.1046 15.6046 22 14.5 22H2.5C1.39543 22 0.5 21.1046 0.5 20V12C0.5 10.8954 1.39543 10 2.5 10H3.5ZM2.5 20V12H14.5V20H2.5ZM9.5 16C9.5 16.5523 9.05229 17 8.5 17C7.94772 17 7.5 16.5523 7.5 16C7.5 15.4477 7.94772 15 8.5 15C9.05229 15 9.5 15.4477 9.5 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.a5226747.svg";
export { ForwardRef as ReactComponent };